import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";

const row = {
  hidden: { opacity: 0, y: 20 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.5, delay: i * 0.05 } }),
};

export const LegalTax = () => {
  const { t } = useLang();
  const LEGAL = t.legal;
  return (
    <section id="legal" className="relative py-24 sm:py-32 bg-[var(--page)] text-[var(--ink)]" data-testid="legal-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[var(--ink)]" />
            <span className="text-[11px] sm:text-xs uppercase tracking-[0.25em] text-[var(--muted-ink)] font-semibold">
              {LEGAL.overline}
            </span>
          </div>
          <h2 className="font-display font-semibold tracking-tight leading-[1.03] text-3xl sm:text-4xl lg:text-5xl">
            {LEGAL.title}
          </h2>
          <p className="mt-6 text-xs uppercase tracking-[0.2em] text-[var(--muted-ink)] font-semibold">{LEGAL.reviewed}</p>
        </div>

        <div className="lg:col-span-7">
          <div className="border-t border-[var(--hairline)]">
            {LEGAL.items.map((it, i) => (
              <motion.div
                key={i}
                custom={i}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-40px" }}
                variants={row}
                data-testid={`legal-row-${i}`}
                className="grid grid-cols-12 gap-4 py-5 sm:py-6 border-b border-[var(--hairline)]"
              >
                <div className="col-span-12 sm:col-span-5">
                  <span className="font-display text-lg sm:text-xl leading-tight">{it.k}</span>
                </div>
                <div className="col-span-12 sm:col-span-7">
                  <span className="text-base text-[var(--muted-ink)] leading-relaxed">{it.v}</span>
                </div>
              </motion.div>
            ))}
          </div>
          <p className="mt-6 text-sm text-[var(--muted-ink)] leading-relaxed">{LEGAL.disclaimer}</p>
        </div>
      </div>
    </section>
  );
};
